import React from 'react';

import { DateInputBonito } from '../../Components/Inputs';
import { DialogoCreateEdit } from '../../Components/modulo-gerencial-dialogos';
import {
  TextInput,
  SwitchInput,
  AutoComleteRemoto,
} from '../../Components/modulo-gerencial-formularios';
import ControllerInput from '../../Components/modulo-gerencial-formularios/inputs/ControllerInput';
import { getListAPI } from '../../services';

const initialValues = {
  username: '',
  passwordNew: '',
  //cargo: null,
  dataAniversario: null,
  is_responsavel: false,
  perfils: [],
};

const validadores = {
  username: (value) => {
    if (!value || value.length < 1) return 'Este campo é obrigatório';
    if (value.length > 80) return 'Não pode ser maior que 80 caracteres';
    return '';
  },
  passwordNew: (value, values, config) => {
    if (value && value.length > 80)
      return 'Não pode ser maior que 80 caracteres';
    return '';
  },
  /* cargo: (value) => {
    if (!value) return 'Este campo é obrigatório';
    return '';
  }, */
  dataAniversario: (value) => {
    if (!value) return 'Este campo é obrigatório';
    return '';
  },
  is_responsavel: () => '',
  perfils: (value) => {
    if (!value) return 'Este campo é obrigatório';
    if (value.length === 0) return 'Este campo é obrigatório';
    return '';
  },
};

const transformGetDados = (dados) => ({
  username: dados.username,
  passwordNew: '',
  //cargo: dados.cargo,
  dataAniversario: dados.dataAniversario,
  is_responsavel: dados.is_responsavel,
  perfils: dados.perfils ? dados.perfils : [],
});

const transformSalvar = (dados, config) => {
  let dia_aniversario = null;
  let mes_aniversario = null;
  let ano_aniversario = null;

  if (dados.dataAniversario) {
    const d = new Date(dados.dataAniversario);
    dia_aniversario = d.getDate();
    mes_aniversario = d.getMonth();
    ano_aniversario = d.getFullYear();
  }

  const payload = {
    username: dados.username,
    //cargo_id: dados.cargo ? dados.cargo.id : null,
    is_responsavel: dados.is_responsavel,
    dia_aniversario,
    mes_aniversario,
    ano_aniversario,
    funcao: 0,
    perfils: dados.perfils ? dados.perfils.map((perfil) => perfil.id) : [],
  };

  if (dados.passwordNew) {
    payload.password = dados.passwordNew;
  }

  return payload;
};

function Form() {
  return (
    <div>
      <TextInput name="username" fullWidth label="Username" autoFocus />
      <TextInput name="passwordNew" fullWidth label="Senha" type="password" />
      <AutoComleteRemoto
        name="perfils"
        getOptionSelected={(option, value) => option.id === value.id}
        getOptionLabel={(option) => `${option.nome}`}
        label="Perfil"
        loadOptions={(termo) =>
          getListAPI('perfils', ['id', 'asc'], [1, 10], { nome: termo }, [])
        }
        fullWidth
        multiple
      />
      <ControllerInput
        name="dataAniversario"
        adapterValueOnChange={(date) => date}
        render={({ field }) => (
          <DateInputBonito
            value={field.value}
            onChange={field.onChange}
            handleEnter={() => {}}
            handleKey={() => {}}
            label="Aniversário"
            fullWidth
            format="dd/MM/yyyy"
            variant="inline"
            inputVariant="outlined"
            style={{ marginTop: '16px', marginBottom: '8px' }}
            error={field.error}
            helperText={field.helperText}
          />
        )}
      />
      <div style={{ marginTop: '8px' }}>
        <SwitchInput name="is_responsavel" label="Gerente de Caixa" />
      </div>
    </div>
  );
}

const Dialogo = ({ onClose, open, id, isDialogoConfirmacaoActions }) => (
  <DialogoCreateEdit
    open={open}
    id={id}
    initialValues={initialValues}
    validators={validadores}
    resource="users"
    titleCreate="Novo Usuário"
    titleUpdate="Editar Usuário"
    nested={['perfils']}
    onClose={onClose}
    transformGetDados={transformGetDados}
    transformSalvar={transformSalvar}
    isCloseTitle
    isDialogoConfirmacaoActions={isDialogoConfirmacaoActions}
  >
    <Form />
  </DialogoCreateEdit>
);

export default Dialogo;
